import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Company } from '../../dto/company';
import { CompanyService } from '../services/company.service';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { RoleService } from '../../services/role.service';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent {
  constructor(
    private route: ActivatedRoute,
    private roleService: RoleService,
    private router: Router,
    private datePipe: DatePipe,
    public companiesService: CompanyService,
  ) { }

  dataSource = new MultiCrudDataSource(this.companiesService);
  columns = [
    { columnDef: 'name', header: 'Name', cell: (row: Company) => `${row.name}` },
    { columnDef: 'directorName', header: 'Director', cell: (row: Company) => `${(row.directorFirstName || '') + ' ' + row.directorName || ''}` },
    { columnDef: 'email', header: 'Email', cell: (row: Company) => `${row.email || ''}` },
    { columnDef: 'address', header: 'Address', cell: (row: Company) => `${row.address || ''}` },
    { columnDef: 'postcode', header: 'Postal code', cell: (row: Company) => `${row.postcode || ''}` },
    { columnDef: 'countryIsoCode', header: 'Country', cell: (row: Company) => `${row.countryName || ''}` },
    { columnDef: 'city', header: 'City', cell: (row: Company) => `${row.city || ''}` },
    { columnDef: 'vatRegNr', header: 'VAT reg nr', cell: (row: Company) => `${row.vatRegNr || ''}` },
  ];

  getViewLink = (item: Company): string => item.id.toString();

  getEditLink = (item: Company): string => item.id.toString() + '/edit';

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }
  deleteEnabled() {
    return this.roleService.hasRoles( 'admin' );
  }
}
